/**
 * The tracking pages are effectively mobile-only surfaces opened from an SMS
 * / notification link, so the design system is mobile-first with a single
 * "wide" breakpoint that just centers the (still narrow) column on desktop.
 * Components should default to mobile styles and opt into `@media` overrides
 * for anything wider — never the reverse.
 *
 * `xl` and `xlLandscape` are the exception: they're not "center the column"
 * tweaks but the threshold for the persistent map + fixed-width panel
 * desktop shell (see `DesktopTrackingShell`, `useIsDesktopViewport`). A
 * portrait viewport only ever crosses `xl` (real desktop windows, which are
 * essentially never that wide in portrait) — portrait tablets stay on the
 * mobile-first layout per spec. A landscape viewport crosses at the lower
 * `xlLandscape` instead, so tablets in landscape (smallest common case:
 * 1024px) also get the desktop shell; it sits well above the widest common
 * phone-landscape width (~932px) so mobile landscape never crosses it.
 */
export const breakpoints = {
  sm: "360px",
  md: "480px",
  lg: "768px",
  xl: "1200px",
  xlLandscape: "1024px",
} as const;

export type BreakpointToken = keyof typeof breakpoints;
